(function () {
    const forms = document.querySelectorAll('.js-register-form, .js-password-form');
    if (!forms.length) {
        return;
    }

    function passwordErrors(password) {
        const errors = [];
        if (password.length < 6) {
            errors.push('Password must be at least 6 characters long.');
        }
        if (!/[A-Z]/.test(password)) {
            errors.push('Password must include at least one capital letter.');
        }
        if (!/\d/.test(password)) {
            errors.push('Password must include at least one digit.');
        }
        return errors;
    }

    function updateRuleStates(ruleItems, password) {
        ruleItems.forEach((item) => {
            const rule = item.getAttribute('data-rule');
            let valid = false;
            if (rule === 'length') {
                valid = password.length >= 6;
            } else if (rule === 'capital') {
                valid = /[A-Z]/.test(password);
            } else if (rule === 'digit') {
                valid = /\d/.test(password);
            }
            item.classList.toggle('is-valid', valid);
            item.classList.toggle('is-invalid', password.length > 0 && !valid);
        });
    }

    function showError(errorEl, message) {
        if (!errorEl) {
            return;
        }
        errorEl.textContent = message;
        errorEl.hidden = !message;
    }

    function syncHowFoundOther(howFoundSelect, howFoundOtherWrap, howFoundOtherInput) {
        if (!howFoundSelect || !howFoundOtherWrap) {
            return;
        }

        const isOther = howFoundSelect.value === 'other';
        howFoundOtherWrap.classList.toggle('d-none', !isOther);

        if (howFoundOtherInput) {
            howFoundOtherInput.required = isOther;
            if (!isOther) {
                howFoundOtherInput.value = '';
            }
        }
    }

    forms.forEach((form) => {
        const isRegisterForm = form.classList.contains('js-register-form');
        const passwordInput = form.querySelector('input[name="password"], input[name="new_password"]');
        const confirmInput = form.querySelector('input[name="password_confirm"], input[name="confirm_password"]');
        const errorEl = form.querySelector('[data-register-error], [data-account-error]');
        const ruleItems = form.querySelectorAll('.auth-password-rules [data-rule]');
        const howFoundSelect = form.querySelector('#registerHowFound');
        const howFoundOtherWrap = form.querySelector('[data-how-found-other-wrap]');
        const howFoundOtherInput = form.querySelector('#registerHowFoundOther');
        const peopleChallengeSelect = form.querySelector('#registerPeopleChallenge');
        const consentInput = form.querySelector('#registerConsent');

        function clearError() {
            showError(errorEl, '');
        }

        if (consentInput) {
            const consentLabel = consentInput.closest('.auth-register-consent__label');
            if (consentLabel) {
                consentLabel.querySelectorAll('a').forEach((link) => {
                    link.addEventListener('click', (event) => {
                        event.stopPropagation();
                    });
                });
            }
            consentInput.addEventListener('change', clearError);
        }

        if (howFoundSelect) {
            howFoundSelect.addEventListener('change', () => {
                syncHowFoundOther(howFoundSelect, howFoundOtherWrap, howFoundOtherInput);
                clearError();
            });
            syncHowFoundOther(howFoundSelect, howFoundOtherWrap, howFoundOtherInput);
        }

        if (passwordInput) {
            passwordInput.addEventListener('input', () => {
                updateRuleStates(ruleItems, passwordInput.value || '');
                clearError();
            });
        }

        if (confirmInput) {
            confirmInput.addEventListener('input', clearError);
        }

        form.addEventListener('submit', (event) => {
            const password = passwordInput ? passwordInput.value : '';
            const confirm = confirmInput ? confirmInput.value : '';

            if (isRegisterForm) {
                const firstName = (form.querySelector('#registerFirstName')?.value || '').trim();
                const lastName = (form.querySelector('#registerLastName')?.value || '').trim();
                const email = (form.querySelector('#registerEmail')?.value || '').trim();
                const businessInput = form.querySelector('#registerBusinessName');
                const industrySelect = form.querySelector('#registerIndustry');
                const employeeSelect = form.querySelector('#registerEmployeeCount');
                const howFound = howFoundSelect?.value || '';
                const howFoundOther = (howFoundOtherInput?.value || '').trim();

                if (!firstName) {
                    event.preventDefault();
                    showError(errorEl, 'Please enter your first name.');
                    return;
                }
                if (!lastName) {
                    event.preventDefault();
                    showError(errorEl, 'Please enter your last name.');
                    return;
                }
                if (!email) {
                    event.preventDefault();
                    showError(errorEl, 'Please enter a valid email address.');
                    return;
                }
                if (businessInput && businessInput.required && !(businessInput.value || '').trim()) {
                    event.preventDefault();
                    showError(errorEl, 'Please enter your business name.');
                    return;
                }
                if (industrySelect && industrySelect.required && !industrySelect.value) {
                    event.preventDefault();
                    showError(errorEl, 'Please select your industry.');
                    return;
                }
                if (employeeSelect && employeeSelect.required && !employeeSelect.value) {
                    event.preventDefault();
                    showError(errorEl, 'Please select the number of employees.');
                    return;
                }
                if (peopleChallengeSelect && peopleChallengeSelect.required && !peopleChallengeSelect.disabled && !peopleChallengeSelect.value) {
                    event.preventDefault();
                    showError(errorEl, 'Please select your biggest people challenge.');
                    return;
                }
                if (howFoundSelect && howFoundSelect.required && !howFound) {
                    event.preventDefault();
                    showError(errorEl, 'Please tell us how you found us.');
                    return;
                }
                if (howFoundSelect && howFound === 'other' && !howFoundOther) {
                    event.preventDefault();
                    showError(errorEl, 'Please tell us how you found us.');
                    return;
                }
                if (consentInput && !consentInput.checked) {
                    event.preventDefault();
                    showError(
                        errorEl,
                        'Please confirm that you agree to the Terms and Conditions and Privacy Policy.'
                    );
                    return;
                }
            }

            const errors = passwordErrors(password);
            updateRuleStates(ruleItems, password);

            if (errors.length) {
                event.preventDefault();
                showError(errorEl, errors[0]);
                return;
            }

            if (password !== confirm) {
                event.preventDefault();
                showError(errorEl, 'Passwords do not match.');
            }
        });

        updateRuleStates(ruleItems, passwordInput ? passwordInput.value || '' : '');
    });
})();
